import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { google } from '@google/maps';

import { AreaService } from 'src/app/arealist.service';


import { CommonService, PropertyType, VentureResources } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';
import { UsersService } from 'src/app/Shared/Users/users.service';
import { VenturesService } from 'src/app/Shared/Venture/ventures.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as QRCode from 'qrcode';
import { environment } from 'src/environments/environment';

import { AIService, VentureContentResponse } from '../../Shared/Venture/ai.service';


declare var google: any;
declare var navigator: any;
declare var $: any;

@Component({
  selector: 'app-ventures',
  templateUrl: './ventures.component.html',
  styleUrls: ['./ventures.component.css']
})
export class VenturesComponent implements OnInit, AfterViewInit {
  singleBranchExpand = true;
  @Input() PortalType: string = 'Mobile';
  @Input() NetworkUserId: number = 0;
  @Input() IsAddVenture: boolean = true;
  isVentureView: boolean = true;
  isLoader: boolean = false;
  ventureForm: FormGroup;
  authData: any;
  areasList: any[] = [];
  propertyList: any[] = [];
  MeasureList: any[] = [];
  amenitiesList: any[] = [];
  ProjectStatusList: any[] = [];
  ventureList: any[] = [];
  Resources: VentureResources[] = [];
  uploadFileTitle: string = '';
  uploadFileType: string = '';
  videoPath: string = '';
  ventureResources: VentureResources[] = [];
  unitsResources: VentureResources[] = [];
  reviewText: string = '';
  selected_rating: string = '';
  EntityID: number = 0;
  uploadFileAcceptTypes: string = 'image/jpeg, image/jpg, image/png';
  ltImage: any[] = [];
  areaSearch: string = '';
  isDropdownOpen: boolean = false;
  isAreaDropdownOpen: boolean = false;
  private selectPickerTimerIds: any[] = [];

  selectedAreaId: number | null = null;
  pdfGenerationInProgress: boolean = false;

  gpsLoaction: string = '';
  mapView: any;
  map: any;
  marker: any;
  geocoder: any;
  isOtherLocation: boolean = false;
  showMap: boolean = false;

  selectedVentureForMap: any = null;
  ventureDynamicContent: Map<number, any> = new Map();


  // Add these properties to your component class
  locationMode: string = 'current'; // 'current', 'other', or 'search'
  searchAddress: string = '';
  searchResults: any[] = [];
  placesService: any; // Google Places service


  ventureLocation: any = {
    lattitude: '',
    longitude: '',
    address: ''
  };

  resourceTypes: any[] = [
    { value: 'VentureLogo', text: 'Venture Logo' },
    { value: 'VentureBrochure', text: 'Venture Brochure' },
    { value: 'VenturePlan', text: 'Venture Plan' },
    { value: 'UnitPlan', text: 'Unit Plan' },
    { value: 'VentureImages', text: 'Venture Images' },
    { value: 'VentureVideos', text: 'Venture Videos' },
    { value: 'WalkthroughVideo', text: 'Walkthrough Video' }  // Add this
  ];

  mapViewIds: any[] = [];
  ventureViewmap: google.maps.Map;

  markers: google.maps.Marker[] = [];

  constructor(private fb: FormBuilder, private ventureCommon: CommonService, private areaService: AreaService
    , private postPropertyPostsService: PropertyPostsService, private ventureService: VenturesService
    , private cdr: ChangeDetectorRef, private postUsersService: UsersService, private http: HttpClient, private sanitizer: DomSanitizer
    , private ngZone: NgZone, private aiService: AIService) {

  }

  ngOnInit(): void {
    this.authData = localStorage.getItem('authData') == undefined ? '' : JSON.parse(localStorage.getItem('authData'));
    this.ProjectStatusList = [];
    this.ventureForm = this.fb.group({
      ProjectID: [0, [Validators.required]],
      ProjectOrVentureName: ['', [Validators.required]],
      ProjectOrVentureID: ['', [Validators.required]],
      Developer_Name: [''],
      AreaID: ['', [Validators.required]],
      Property_Type: [PropertyType.Residential, [Validators.required]],
      Amenities: [[], [Validators.required]],
      UnitId: ['', [Validators.required]],
      UnitMeasures: ['', [Validators.required]],
      Open_Space: ['', [Validators.required]],
      Blocks: ['', [Validators.required]],
      NumberOfFloors: ['', [Validators.required]],
      NumberOfUnitsOrPlots: ['', [Validators.required]],
      TypesOfUnits: ['', [Validators.required]],
      PricingDetails: ['', [Validators.required]],
      ProjectStatus: ['', [Validators.required]],
      LaunchDate: ['', [Validators.required]],
      CompletionDate: ['', [Validators.required]],
      LegalApprovals: ['', [Validators.required]],
      Project_Logo: ['', [Validators.required]],
      Project_Brochure: [''],
      ProjectVenture_Plan: [''],
      Overview: ['', [Validators.required]],
      UserID: [this.authData.UserID, [Validators.required]],
      Status: [0, [Validators.required]],
      Latitude: [''],
      Longitude: [''],
      YouTubeUrl: [''],
      FacebookUrl: [''],
      InstagramUrl: [''],
      Whatsapp: [''],
      Telegram: ['']
    });

    this.areasList = this.areaService.getAreas();
    this.loadMapBasedOnAddress();
    this.LoadMeasures();
    this.LoadAmenities();
    this.LoadVentureList();
    this.ProjectStatusList.push({ value: "Under Construction", text: "Under Construction" });
    this.ProjectStatusList.push({ value: "Ready to Occupy", text: "Ready to Occupy" });
    this.ProjectStatusList.push({ value: "Completed", text: "Completed" });
  }

  private LoadVentureList() {
    console.log('LoadVentureList: Started');

    try {
      this.ventureList = [];
      let userId = this.authData.UserID;
      console.log('LoadVentureList: authData present?', !!this.authData);
      console.log('LoadVentureList: NetworkUserId:', this.NetworkUserId);
      console.log('LoadVentureList: Original userId:', userId);

      if (this.NetworkUserId == 0 || this.NetworkUserId == undefined || this.NetworkUserId == null) {
        userId = this.authData.UserID;
        console.log('LoadVentureList: Using authData userId:', userId);
      } else {
        userId = this.NetworkUserId;
        console.log('LoadVentureList: Using NetworkUserId:', userId);
      }

      console.log('LoadVentureList: Calling API with userId:', userId, 'ventureId: empty', 'status: 0');

      this.ventureService.GetVentureDetails('', userId, 0).subscribe({
        next: (res) => {
          console.log('LoadVentureList: API Response received', { status: res.status, bodyLength: res.body?.length });

          try {
            if (res.status == 1) {
              this.ventureList = res.body;
              console.log('LoadVentureList: ventureList length:', this.ventureList.length);

              this.ventureList.forEach((e, index) => {

                if (e.Project_Logo) {
                  e.Project_Logo = this.normalizeImageUrl(e.Project_Logo);
                }
                if (e.Project_Brochure) {
                  e.Project_Brochure = this.normalizeImageUrl(e.Project_Brochure);
                }

                console.log(`LoadVentureList: Processing venture ${index + 1}/${this.ventureList.length}`, {
                  ProjectID: e.ProjectID,
                  ProjectName: e.ProjectOrVentureName
                });

                // Parse Amenities JSON
                try {
                  if (e.Aminity_JSON) {
                    e.Aminity_JSON = JSON.parse(e.Aminity_JSON);
                    console.log(`LoadVentureList: Parsed Amenities for ${e.ProjectID}`, e.Aminity_JSON);
                  } else {
                    e.Aminity_JSON = [];
                    console.log(`LoadVentureList: No Amenities for ${e.ProjectID}`);
                  }
                } catch (parseErr) {
                  console.error(`LoadVentureList: Error parsing Amenities for ${e.ProjectID}:`, parseErr);
                  e.Aminity_JSON = [];
                }

                // Parse DynamicContent if it exists
                console.log(`LoadVentureList: DynamicContent for Project ${e.ProjectID}:`, e.DynamicContent ? 'exists' : 'null');

                try {
                  if (e.DynamicContent && e.DynamicContent != '' && e.DynamicContent != 'null' && e.DynamicContent != 'undefined') {
                    const parsedContent = JSON.parse(e.DynamicContent);
                    this.ventureDynamicContent.set(e.ProjectID, parsedContent);
                    console.log(`LoadVentureList: Successfully parsed DynamicContent for project ${e.ProjectID}`, parsedContent);
                  } else {
                    console.log(`LoadVentureList: No DynamicContent for project ${e.ProjectID} - using default`);
                    this.ventureDynamicContent.set(e.ProjectID, this.getDefaultContentJSON(e));
                  }
                } catch (parseError) {
                  console.error(`LoadVentureList: Error parsing DynamicContent for project ${e.ProjectID}:`, parseError);
                  this.ventureDynamicContent.set(e.ProjectID, this.getDefaultContentJSON(e));
                }

                // Parse Project Resources
                try {
                  if (e.ProjectResources_JSON != null && e.ProjectResources_JSON != undefined && e.ProjectResources_JSON != '') {
                    this.ventureResources = [];
                    let resList = JSON.parse(e.ProjectResources_JSON);
                    console.log(`LoadVentureList: Parsed ProjectResources for ${e.ProjectID}`, { count: resList.length });

                    resList.forEach(r => {
                      let resource: VentureResources = {
                        ContentType: r.ContentType,
                        FileName: r.FileName,
                        FileType: r.FileType,
                        Label: r.Label,
                        isVideo: r.isVideo,
                        isImage: r.isImage,
                        isDocument: r.isDocument,
                        isResources: true
                      };
                      this.ventureResources.push(resource);
                    });
                    e.ProjectResources_JSON = this.ventureResources;
                    e.UnitResources_Json = this.ventureResources.filter(r => r.ContentType == 'UnitPlan') ?? [];
                    e.ProjectVenture_Plan = this.ventureResources.find(r => r.ContentType == 'VenturePlan') ?? null;
                    console.log(`LoadVentureList: Processed resources for ${e.ProjectID}`, {
                      totalResources: this.ventureResources.length,
                      unitPlans: e.UnitResources_Json.length,
                      hasVenturePlan: !!e.ProjectVenture_Plan
                    });
                  } else {
                    console.log(`LoadVentureList: No ProjectResources for ${e.ProjectID}`);
                    e.ProjectResources_JSON = [];
                    e.UnitResources_Json = [];
                  }
                } catch (resErr) {
                  console.error(`LoadVentureList: Error parsing ProjectResources for ${e.ProjectID}:`, resErr);
                  e.ProjectResources_JSON = [];
                  e.UnitResources_Json = [];
                }

                // Process map coordinates
                try {
                  if (e.Latitude != null && e.Latitude != undefined && e.Latitude != '' &&
                    e.Longitude != null && e.Longitude != undefined && e.Longitude != '') {
                    this.mapViewIds.push({
                      ProjectID: e.ProjectID,
                      Latitude: parseFloat(e.Latitude),
                      Longitude: parseFloat(e.Longitude)
                    });
                    console.log(`LoadVentureList: Added map coordinates for ${e.ProjectID}`, {
                      lat: e.Latitude,
                      lng: e.Longitude
                    });
                  } else {
                    console.log(`LoadVentureList: No coordinates for ${e.ProjectID}`);
                  }
                } catch (coordErr) {
                  console.error(`LoadVentureList: Error processing coordinates for ${e.ProjectID}:`, coordErr);
                }
              });

              console.log('LoadVentureList: Finished processing all ventures, mapViewIds count:', this.mapViewIds.length);

              // Force change detection to update the view
              this.cdr.detectChanges();
              console.log('LoadVentureList: Change detection triggered');

              setTimeout(() => {
                console.log('LoadVentureList: Calling EnableVentureViewMap');
                this.EnableVentureViewMap();
              }, 5000);
            } else {
              console.error('LoadVentureList: API returned status != 1', { status: res.status, message: res.message });
              this.ventureCommon.CallToster('E', 'Unable to find the project / venture details...');
            }
          } catch (processingErr) {
            console.error('LoadVentureList: Error processing API response:', processingErr);
            this.ventureCommon.CallToster('E', 'Error processing venture data');
          }
        },
        error: (err) => {
          console.error('LoadVentureList: API call failed with error:', {
            status: err.status,
            statusText: err.statusText,
            message: err.message,
            error: err.error,
            url: err.url
          });

          // Log additional details about the error
          if (err.error && typeof err.error === 'object') {
            console.error('LoadVentureList: Error details:', JSON.stringify(err.error));
          }

          this.ventureCommon.CallToster('E', 'Unable to get the project / venture details...');
          this.isLoader = false;
        }
      });
    } catch (err) {
      console.error('LoadVentureList: Outer try-catch caught error:', err);
      this.isLoader = false;
      this.ventureCommon.CallToster('E', 'Something went wrong while loading venture details');
    }
  }

  // Helper method to safely get dynamic content
  getDynamicContent(projectId: number): any {
    const content = this.ventureDynamicContent.get(projectId);
    if (content && content !== 'undefined') {
      return content;
    }
    // Find the venture to get default content
    const venture = this.ventureList.find(v => v.ProjectID === projectId);
    if (venture) {
      return JSON.parse(this.getDefaultContentJSON(venture));
    }
    return null;
  }

  LoadMeasures() {
    this.MeasureList = [];
    this.postPropertyPostsService.GetAllUnitsList(0).subscribe((res) => {
      if (res.status == 1) {
        this.MeasureList = res.body;
      }
    });
  }

  LoadAmenities() {
    this.amenitiesList = [];
    this.ventureService.GetAllAmenitiesList().subscribe((res) => {
      if (res.status == 1) {
        this.amenitiesList = res.body;
        if (!this.isVentureView) {
          this.cdr.detectChanges();
          setTimeout(() => this.initSelectPickers(), 100);
        }
      }
    });
  }

  async generateAndStoreAIContent(venture: any): Promise<string> {
    try {
      // Determine venture category from Property_Type
      let ventureCategory = 1; // Default to Residential

      if (venture.Property_Type) {
        ventureCategory = venture.Property_Type;
      } else if (this.ventureForm.controls['Property_Type'].value) {
        ventureCategory = this.ventureForm.controls['Property_Type'].value;
      }

      // Create the request object
      const requestPayload = {
        areaName: venture.AreaName,
        latitude: parseFloat(venture.Latitude),
        longitude: parseFloat(venture.Longitude),
        ventureName: venture.ProjectOrVentureName,
        ventureCategory: ventureCategory
      };

      console.log('Calling AI API with payload:', requestPayload);

      const response: any = await this.aiService.generateVentureContent(requestPayload).toPromise();

      if (response && response.status === 1 && response.content) {
        console.log('AI content generated successfully');

        // Parse and enhance the content with additional computed data
        const parsedContent = JSON.parse(response.content);
        const enhancedContent = this.enhanceAIContent(parsedContent, venture, ventureCategory);

        return JSON.stringify(enhancedContent);
      } else {
        console.warn('AI response invalid, using default content');
        return this.getDefaultContentJSON(venture);
      }
    } catch (error) {
      console.error('AI generation failed:', error);
      return this.getDefaultContentJSON(venture);
    }
  }

  // Add this method to enhance AI content with additional computed data
  private enhanceAIContent(content: any, venture: any, category: number): any {
    const priceUnit = category === 3 ? 'per sq.yd' : 'per sq.ft';

    // Add computed investment metrics
    if (!content.investment) {
      content.investment = {
        presentAvgRate: category === 3 ? 'â‚¹40,000 - â‚¹75,000 per sq.yd' : 'â‚¹8,000 - â‚¹12,000 per sq.ft',
        lastYearAvgRate: category === 3 ? 'â‚¹20,000 - â‚¹40,000 per sq.yd' : 'â‚¹5,000 - â‚¹8,000 per sq.ft',
        yoYGrowth: '15-20%',
        fiveYearTrend: '47% growth over 5 years',
        demandSupply: 'Demand: High | Supply: Medium',
        investmentOutlook: 'Positive',
        riskLevel: 'Medium',
        recommendedHorizon: '5-10 years'
      };
    }

    // Add property-specific data based on category
    if (!content.propertySpecific) {
      switch (category) {
        case 1: // Residential
          content.propertySpecific = {
            bhkConfigurations: ['1BHK', '2BHK', '3BHK', '4BHK'],
            rentalYield: '3-4% annually'
          };
          break;
        case 2: // Commercial
          content.propertySpecific = {
            footfallAnalysis: 'High footfall during business hours',
            rentalIncomePotential: 'â‚¹50-100 per sq.ft per month',
            parkingAvailability: 'Ample parking available'
          };
          break;
        case 3: // Land
          content.propertySpecific = {
            plotSizes: ['200 sq.yds', '500 sq.yds', '1000+ sq.yds'],
            approvalStatus: 'HMDA/DTCP approved',
            futureDevelopment: 'Residential and commercial projects planned'
          };
          break;
      }
    }

    // Add demographics if not present
    if (!content.demographics) {
      content.demographics = {
        populationDensity: 'Medium-High',
        incomeLevel: 'Upper-Middle to High',
        ageGroup: '25-45 years (Working professionals)',
        occupationProfile: 'IT professionals, Business owners'
      };
    }

    return content;
  }

  // Update getDefaultContentJSON to be more comprehensive
  getDefaultContentJSON(venture: any): string {
    const category = venture.Property_Type || 1;
    const areaName = venture.AreaName || 'this location';
    const priceUnit = category === 3 ? 'per sq.yd' : 'per sq.ft';

    let defaultContent: any = {
      locationInsights: {
        areaRating: {
          overall: 4.2,
          connectivity: 4.3,
          investmentPotential: 4.1,
          development: 4.0,
          livability: 4.0,
          safety: 4.2,
          environment: 4.0
        },
        accessibilityScore: {
          score: 8.0,
          airport: '30-40 km',
          metro: '5-15 km',
          highway: '2-5 km',
          busConnectivity: 'Good',
          railwayStation: '15-25 km',
          itHub: '2-10 km'
        },
        developmentMetrics: {
          infrastructure: 'Good',
          roads: 'Average',
          softwareCompanies: 'Very Good',
          developmentProjects: 'Good',
          futureOutlook: 'Positive'
        }
      },
      locationConnectivity: {
        roadConnectivity: [
          `Connectivity near ${areaName}`,
          'Outer Ring Road',
          'Local transport network'
        ],
        keyDistances: [
          'Airport: 30 km',
          'Railway Station: 20 km',
          'Metro: 5 km',
          'IT Hub: 2 km'
        ],
        locationAdvantage: [
          'Strategic location',
          'Excellent connectivity',
          'Rapid infrastructure development',
          'High growth potential'
        ]
      },
      nearby: {
        schools: [{ name: `Schools in ${areaName}`, description: 'Educational institutions', tag: 'Education', distance: 3.0, rating: 4.0 }],
        hospitals: [{ name: `Hospitals near ${areaName}`, description: 'Healthcare facilities', tag: 'Healthcare', distance: 4.0, rating: 4.0 }],
        itCompanies: [{ name: 'IT Parks', description: 'Employment hubs nearby', tag: 'Employment Hub', distance: 5.0, rating: 4.2 }],
        businessHubs: [{ name: 'Commercial District', description: 'Business center', tag: 'Business', distance: 3.0, rating: 4.1 }],
        malls: [],
        metroStations: []
      },
      analytics: [
        {
          title: category === 3 ? 'Price Trends (Open Plots)' : `Price Trends (${category === 1 ? 'Residential' : 'Commercial'})`,
          details: [
            `2020: â‚¹10,000 - â‚¹20,000 ${priceUnit}`,
            `2023: â‚¹20,000 - â‚¹40,000 ${priceUnit}`,
            `2026: â‚¹40,000 - â‚¹75,000 ${priceUnit}`
          ],
          tag: 'Appreciation'
        },
        {
          title: 'Market Analysis',
          details: [
            'Demand: High',
            'Supply: Medium',
            'Investment Outlook: Positive'
          ],
          tag: 'Market'
        },
        {
          title: 'Growth Potential',
          details: [
            'Expected appreciation: 15-20%',
            'Key drivers: Infrastructure development',
            'Investment horizon: 5-10 years'
          ],
          tag: 'Growth'
        }
      ],
      propertySpecific: {},
      demographics: {},
      investment: {}
    };

    // Add category-specific default data
    switch (category) {
      case 1: // Residential
        defaultContent.propertySpecific = {
          bhkConfigurations: ['1BHK', '2BHK', '3BHK', '4BHK'],
          rentalYield: '3-4% annually'
        };
        defaultContent.demographics = {
          populationDensity: 'Medium-High',
          incomeLevel: 'Upper-Middle',
          ageGroup: '25-45 years',
          occupationProfile: 'IT professionals, Entrepreneurs'
        };
        defaultContent.investment = {
          presentAvgRate: 'â‚¹8,000 - â‚¹12,000 per sq.ft',
          lastYearAvgRate: 'â‚¹5,000 - â‚¹8,000 per sq.ft',
          yoYGrowth: '15-20%',
          fiveYearTrend: '47% growth over 5 years',
          demandSupply: 'Demand: High | Supply: Medium',
          investmentOutlook: 'Positive',
          riskLevel: 'Medium',
          recommendedHorizon: '5-10 years'
        };
        break;

      case 2: // Commercial
        defaultContent.propertySpecific = {
          footfallAnalysis: 'High footfall during business hours',
          rentalIncomePotential: 'â‚¹50-100 per sq.ft per month',
          parkingAvailability: 'Ample parking available'
        };
        defaultContent.demographics = {
          populationDensity: 'High during business hours',
          incomeLevel: 'High',
          ageGroup: '25-50 years',
          occupationProfile: 'Business owners, Corporate employees'
        };
        defaultContent.investment = {
          presentAvgRate: 'â‚¹11,000 - â‚¹16,000 per sq.ft',
          lastYearAvgRate: 'â‚¹7,000 - â‚¹11,000 per sq.ft',
          yoYGrowth: '12-18%',
          fiveYearTrend: '40% growth over 5 years',
          demandSupply: 'Demand: High | Supply: Moderate',
          investmentOutlook: 'Positive',
          riskLevel: 'Low-Medium',
          recommendedHorizon: '7-12 years'
        };
        break;

      case 3: // Land
        defaultContent.propertySpecific = {
          plotSizes: ['200 sq.yds', '500 sq.yds', '1000+ sq.yds'],
          approvalStatus: 'HMDA/DTCP approved',
          futureDevelopment: 'Residential and commercial projects planned'
        };
        defaultContent.demographics = {
          populationDensity: 'Developing',
          incomeLevel: 'Varied',
          ageGroup: 'All age groups',
          occupationProfile: 'Investors, Developers'
        };
        defaultContent.investment = {
          presentAvgRate: 'â‚¹40,000 - â‚¹75,000 per sq.yd',
          lastYearAvgRate: 'â‚¹20,000 - â‚¹40,000 per sq.yd',
          yoYGrowth: '20-25%',
          fiveYearTrend: '60% growth over 5 years',
          demandSupply: 'Demand: Growing | Supply: Limited',
          investmentOutlook: 'Very Positive',
          riskLevel: 'Medium',
          recommendedHorizon: '5-7 years'
        };
        break;
    }

    return JSON.stringify(defaultContent);
  }

  // Add helper method to get formatted content for display
  getFormattedContent(projectId: number): any {
    const content = this.ventureDynamicContent.get(projectId);
    if (content && content !== 'undefined') {
      return content;
    }
    return null;
  }

  // Add method to check if content has specific section
  hasContentSection(projectId: number, section: string): boolean {
    const content = this.ventureDynamicContent.get(projectId);
    return content && content[section] && Object.keys(content[section]).length > 0;
  }



  async doSaveVentureDetails() {
    try {
      if (this.authData == undefined || this.authData == null || this.authData.UserID == undefined || this.authData.UserID == null) {
        this.ventureCommon.CallToster('W', 'Please login to save your venture details');
        return;
      }

      // FIXED: Use 'lattitude' consistently (double t)
      if (this.ventureLocation.lattitude == '' || this.ventureLocation.lattitude == undefined || this.ventureLocation.lattitude == null) {
        this.ventureCommon.CallToster('W', 'Please select location');
        return;
      }

      if (this.ventureForm.valid) {
        // FIXED: Use 'lattitude' consistently
        if (this.ventureLocation.lattitude == '' || this.ventureLocation.lattitude == undefined || this.ventureLocation.lattitude == null) {
          this.ventureCommon.CallToster('W', 'Please select location');
          return;
        }
        if (this.ventureLocation.longitude == '' || this.ventureLocation.longitude == undefined || this.ventureLocation.longitude == null) {
          this.ventureCommon.CallToster('W', 'Please select location');
          return;
        }
        if (this.ventureForm.controls['Project_Logo'].value == '' || this.ventureForm.controls['Project_Logo'].value == undefined) {
          this.ventureCommon.CallToster('W', 'Please upload venture logo');
          return;
        }
        if (this.ventureForm.controls['Project_Brochure'].value == '' || this.ventureForm.controls['Project_Brochure'].value == undefined) {
          this.ventureCommon.CallToster('W', 'Please upload venture brochure');
          return;
        }
        if (this.Resources.length == 0) {
          this.ventureCommon.CallToster('W', 'Please upload the venture resources...!');
          return;
        }
        if (this.Resources.find(x => x.ContentType == "VenturePlan") == null) {
          this.ventureCommon.CallToster('W', 'Please upload the venture plan...!');
          return;
        }

        // FIXED: Use 'lattitude' consistently (not 'latitude')
        if (this.locationMode === 'current' || this.locationMode === 'other') {
          if (this.ventureLocation.lattitude == '' || this.ventureLocation.lattitude == undefined) {
            this.ventureCommon.CallToster('W', this.locationMode === 'current' ?
              'Unable to get current location. Please enable location services or use Search Location option.' :
              'Please select a location by dragging the marker');
            return;
          }
        } else if (this.locationMode === 'search') {
          if (this.ventureLocation.lattitude == '' || this.ventureLocation.lattitude == undefined) {
            this.ventureCommon.CallToster('W', 'Please search and select a location');
            return;
          }
        }

        this.isLoader = true;
        let postData = this.ventureForm.value;
        let selectedAmenitiesList = [];
        let resourcesList = [];
        let amenities = '';
        selectedAmenitiesList = this.ventureForm.controls['Amenities'].value;
        selectedAmenitiesList.forEach(e => {
          amenities += e + ',';
        });
        resourcesList = this.Resources.filter(e => e.isResources == true);
        postData.Amenities = amenities;
        postData.Latitude = this.ventureLocation.lattitude.toString();
        postData.Longitude = this.ventureLocation.longitude.toString();
        postData.ProjectResources = resourcesList;

        // NORMALIZE SOCIAL MEDIA URLs BEFORE SENDING
        postData = this.normalizeSocialMediaUrls(postData);

        // Get Area Name
        const areaName = this.getSelectedAreaName();
        const ventureInfo = {
          ProjectOrVentureName: postData.ProjectOrVentureName,
          AreaName: areaName,
          Latitude: postData.Latitude,
          Longitude: postData.Longitude,
          Property_Type: postData.Property_Type
        };

        // Generate AI content if AreaName, Latitude, Longitude are available
        let aiContent = '';
        if (areaName && postData.Latitude && postData.Longitude) {
          this.updateLoaderProgress(0, 'ðŸ¤– Generating AI content for location...');
          try {
            aiContent = await this.generateAndStoreAIContent(ventureInfo);
            postData.DynamicContent = aiContent;
          } catch (aiError) {
            console.error('AI generation failed:', aiError);
            postData.DynamicContent = this.getDefaultContentJSON(ventureInfo);
          }
        } else {
          postData.DynamicContent = this.getDefaultContentJSON(ventureInfo);
        }

        this.updateLoaderProgress(50, 'ðŸ’¾ Saving venture details...');

        this.ventureService.SaveVentureDEtails(postData).subscribe((res) => {
          this.isLoader = false;
          if (res.status == 1) {
            let resBody = res.body;
            if (parseInt(resBody.ProjectId) > 0) {
              this.ventureCommon.CallToster('S', 'Your venture / project details saved successfully');
              this.isVentureView = true;
              this.LoadVentureList();
              this.ventureForm.reset();
              this.Resources = [];
              this.uploadFileTitle = '';
              this.uploadFileType = '';
              this.loadVentureTab();
            } else {
              this.ventureCommon.CallToster('W', 'Unable to save your venture / project details, Please try later.');
            }
          } else {
            this.ventureCommon.CallToster('W', 'Unable to save your venture / project details, Please try later.');
          }
          this.updateLoaderProgress(100, 'âœ… Complete!');
        }, err => {
          this.isLoader = false;
          this.ventureCommon.CallToster('W', 'Something went wrong, Please try later');
          console.error('Save error:', err);
        });
      } else {
        this.isLoader = false;
        this.ventureCommon.CallToster('W', 'Please enter all details');
      }
    } catch (error) {
      this.isLoader = false;
      this.ventureCommon.CallToster('W', 'Something went wrong, Please try later');
      console.error('Error in save:', error);
    }
  }


  selectRadio(radioButtonId: string) {
    const radioButton = document.getElementById(radioButtonId) as HTMLInputElement;
    if (radioButton) {
      radioButton.click();
    }
  }

  doChangeLocation(locationType: number) {
    if (locationType === 1) { // Current Location
      this.locationMode = 'current';
      this.searchAddress = '';
      this.searchResults = [];
      document.getElementById('txtDescription')?.removeAttribute('readonly');

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.ventureLocation.lattitude = position.coords.latitude;
          this.ventureLocation.longitude = position.coords.longitude;
          // ALSO UPDATE THE FORM
          this.ventureForm.patchValue({
            Latitude: position.coords.latitude,
            Longitude: position.coords.longitude
          });
          this.updateAddress(parseFloat(this.ventureLocation.lattitude), parseFloat(this.ventureLocation.longitude));
          this.initMap();
          this.showMap = true;
        }, error => {
          console.error('Geolocation failed: ' + error.message);
          this.ventureCommon.CallToster('E', 'Unable to get current location. Please enable location services.');
        });
      } else {
        console.error('Geolocation is not supported by this browser.');
        this.ventureCommon.CallToster('E', 'Geolocation is not supported by your browser');
      }
    }
    else if (locationType === 0) { // Other Location (Manual drag)
      this.locationMode = 'other';
      this.searchAddress = '';
      this.searchResults = [];
      document.getElementById('txtDescription')?.removeAttribute('readonly');
      this.ventureLocation.address = '';
      this.showMap = false;

      if (this.map) {
        this.marker?.setMap(null);
        this.marker = null;
        const mapDiv = document.getElementById('map');
        if (mapDiv) {
          mapDiv.innerHTML = '';
        }
        this.map = null;
      }
      // Re-initialize map for manual location
      setTimeout(() => {
        this.initMap();
        this.showMap = true;
      }, 100);
    }
    else if (locationType === 2) { // Search Location
      this.locationMode = 'search';
      this.searchAddress = '';
      this.searchResults = [];
      document.getElementById('txtDescription')?.setAttribute('readonly', 'readonly');
      this.ventureLocation.address = '';
      this.showMap = false;

      // Initialize Places service
      if (!this.placesService && google && google.maps) {
        const mapDiv = document.createElement('div');
        this.placesService = new google.maps.places.AutocompleteService();
      }

      // Clear existing map
      if (this.map) {
        this.marker?.setMap(null);
        this.marker = null;
      }

      // Focus on search input
      setTimeout(() => {
        const searchInput = document.getElementById('searchLocationInput');
        searchInput?.focus();
      }, 100);
    }
  }

  // Search location using Google Places API
  searchLocation() {
    if (!this.searchAddress || this.searchAddress.trim() === '') {
      this.ventureCommon.CallToster('W', 'Please enter an address to search');
      return;
    }

    this.isLoader = true;

    // Use Geocoder for address search
    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder();
    }

    this.geocoder.geocode({ address: this.searchAddress }, (results: any, status: any) => {
      this.isLoader = false;

      if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
        this.searchResults = results;

        // Auto-select if only one result
        if (results.length === 1) {
          this.selectSearchResult(results[0]);
        } else {
          this.ventureCommon.CallToster('S', `${results.length} locations found. Please select one.`);
        }
      } else {
        this.ventureCommon.CallToster('W', 'No locations found. Please try a different address.');
        this.searchResults = [];
      }
    });
  }

  // Select a location from search results
  // Select a location from search results
  selectSearchResult(result: any) {
    const location = result.geometry.location;
    const lat = location.lat();
    const lng = location.lng();

    this.ventureLocation.lattitude = lat.toString();
    this.ventureLocation.longitude = lng.toString();
    this.ventureLocation.address = result.formatted_address;

    // ALSO UPDATE THE FORM
    this.ventureForm.patchValue({
      Latitude: lat.toString(),
      Longitude: lng.toString()
    });

    // Clear search results
    this.searchResults = [];
    this.searchAddress = '';

    // Force map re-initialization with a small delay to ensure DOM is ready
    setTimeout(() => {
      // Destroy existing map if any
      if (this.mapView) {
        // Clean up existing markers
        if (this.marker) {
          this.marker.setMap(null);
          this.marker = null;
        }
        // Clear the map div
        const mapContainer = document.getElementById('venturePostMap');
        if (mapContainer) {
          mapContainer.innerHTML = '';
        }
        this.mapView = null;
      }

      // Initialize new map with the selected location
      this.initMap();
      this.showMap = true;

      // Also update the geocoder address
      if (this.geocoder) {
        const latlng = { lat: lat, lng: lng };
        this.geocoder.geocode({ 'location': latlng }, (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK && results[0]) {
            this.ventureLocation.address = results[0].formatted_address;
            this.GetAddress(this.ventureLocation.address);
          }
        });
      }
    }, 100);
  }

  // Optional: Add autocomplete for better UX
  setupAutocomplete() {
    const searchInput = document.getElementById('searchLocationInput') as HTMLInputElement;
    if (searchInput && google && google.maps && google.maps.places) {
      const autocomplete = new google.maps.places.Autocomplete(searchInput, {
        types: ['geocode', 'establishment'],
        componentRestrictions: { country: 'IN' } // Change as needed
      });

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          this.ventureLocation.lattitude = lat.toString();
          this.ventureLocation.longitude = lng.toString();
          this.ventureLocation.address = place.formatted_address;

          this.updateAddress(lat, lng);
          this.initMap();
          this.showMap = true;
          this.searchResults = [];
        }
      });
    }
  }

  initMap() {
    // Check if we have coordinates
    if (!this.ventureLocation.lattitude || !this.ventureLocation.longitude) {
      console.warn('No coordinates available for map');
      return;
    }

    const mapElement = document.getElementById('venturePostMap');
    if (!mapElement) {
      console.warn('Map element not found');
      return;
    }

    const mapOptions = {
      center: {
        lat: parseFloat(this.ventureLocation.lattitude),
        lng: parseFloat(this.ventureLocation.longitude)
      },
      zoom: 17,  // Increased zoom for better accuracy
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    // Create new map if doesn't exist, or update existing
    if (!this.mapView) {
      this.mapView = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: {
          lat: parseFloat(this.ventureLocation.lattitude),
          lng: parseFloat(this.ventureLocation.longitude)
        },
        map: this.mapView,
        draggable: this.locationMode !== 'search', // Make draggable only for 'other' mode
        animation: google.maps.Animation.DROP
      });

      // Only add drag listener for 'other' mode
      if (this.locationMode !== 'search') {
        this.marker.addListener('dragend', (event: any) => {
          this.updateAddress(event.latLng.lat(), event.latLng.lng());
        });
      }
    } else {
      // Update existing map
      const newCenter = new google.maps.LatLng(
        parseFloat(this.ventureLocation.lattitude),
        parseFloat(this.ventureLocation.longitude)
      );
      this.mapView.setCenter(newCenter);
      this.mapView.setZoom(17);

      if (this.marker) {
        this.marker.setPosition(newCenter);
        this.marker.setDraggable(this.locationMode !== 'search');
      }
    }
  }


  refreshMap() {
    if (this.mapView && this.ventureLocation.lattitude && this.ventureLocation.longitude) {
      const center = new google.maps.LatLng(
        parseFloat(this.ventureLocation.lattitude),
        parseFloat(this.ventureLocation.longitude)
      );
      this.mapView.setCenter(center);
      this.mapView.setZoom(17);

      if (this.marker) {
        this.marker.setPosition(center);
      }
    }
  }


  updateAddress(lat: number, lng: number) {
    const latlng = { lat, lng };
    this.geocoder.geocode({ 'location': latlng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          this.ventureLocation.address = results[0].formatted_address;
          this.ventureLocation.lattitude = lat.toString();
          this.ventureLocation.longitude = lng.toString();
          this.GetAddress(this.ventureLocation.address);
        }
      } else {
        console.error('Geocode was not successful for the following reason: ' + status);
      }
    });
  }

  GetAddress(address: string) {
    const path = `https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1s${this.ventureLocation.lattitude},${this.ventureLocation.longitude}!6i14!3m1!1sen!5m1!1sen&zoom=15`;
    this.gpsLoaction = path;
  }

  loadMapBasedOnAddress() {
    try {
      setTimeout(() => {
        if (!this.geocoder) {
          this.geocoder = new google.maps.Geocoder();
        }
        if (this.ventureLocation.address && this.ventureLocation.address.trim() !== '') {
          this.geocodeAddress(this.ventureLocation.address);
        }
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  }

  geocodeAddress(address: string) {
    this.geocoder.geocode({ 'address': address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        const location = results[0].geometry.location;
        this.ventureLocation.lattitude = location.lat();
        this.ventureLocation.longitude = location.lng();
        this.initMap();
        this.showMap = true;
      } else {
        console.error('Geocode was not successful for the following reason: ' + status);
      }
    });
  }

  loadVentureTab() {
    const ventureTab = document.querySelector('#nav-venture-tab') as HTMLElement;
    if (ventureTab) {
      ventureTab.click();
      this.scrollToSearchSection();
    }
  }


  UpdateDate(event, type: string) {
    if (type == 'LD') {
      setTimeout(() => {
        this.ventureForm.controls['LaunchDate'].setValue(event.target.value);
      }, 500);
    }
    else {
      setTimeout(() => {
        this.ventureForm.controls['CompletionDate'].setValue(event.target.value);
      }, 500);
    }
  }

  ViewVentureBroucher(brochure: string): void {
    if (brochure && brochure.trim() !== '') {
      window.open(brochure, '_blank');
    } else {
      this.ventureCommon.CallToster('W', 'Media path is not available.');
    }
  }

  ViewMedia(mediaPath: string, type?: string): void {
    if (!mediaPath) return;

    let fullPath = mediaPath;

    // Handle different social media types
    if (type === 'youtube') {
      fullPath = this.getYouTubeUrl(mediaPath);
    } else if (type === 'facebook') {
      fullPath = this.getFacebookUrl(mediaPath);
    } else if (type === 'instagram') {
      fullPath = this.getInstagramUrl(mediaPath);
    } else if (type === 'whatsapp') {
      fullPath = this.getWhatsAppUrl(mediaPath);
    } else if (type === 'telegram') {
      fullPath = this.getTelegramUrl(mediaPath);
    } else {
      // Auto-detect based on content
      if (mediaPath.match(/^[\+]?[0-9]{10,15}$/)) {
        fullPath = this.getWhatsAppUrl(mediaPath);
      } else if (mediaPath.includes('youtube.com') || mediaPath.includes('youtu.be')) {
        fullPath = this.getYouTubeUrl(mediaPath);
      } else if (mediaPath.includes('facebook.com')) {
        fullPath = this.getFacebookUrl(mediaPath);
      } else if (mediaPath.includes('instagram.com')) {
        fullPath = this.getInstagramUrl(mediaPath);
      } else if (mediaPath.includes('t.me')) {
        fullPath = this.getTelegramUrl(mediaPath);
      } else if (!mediaPath.startsWith('http')) {
        fullPath = `https://${mediaPath}`;
      }
    }

    window.open(fullPath, '_blank');
  }

  ViewImages(imgs: any[]) {
    this.ltImage = [];
    if (imgs.length > 0) {
      imgs.forEach(x => {
        if (x.FileType == 'Image')
          this.ltImage.push(x.FileName);
      });
    }
    this.cdr.detectChanges();
    $('#ImageViewModal').modal('toggle');
  }

  ResetImageView() {
    this.ltImage = [];
  }

  ShowVentureAdd() {
    this.isVentureView = false;
    setTimeout(() => {
      this.cdr.detectChanges();
      this.initSelectPickers();
      this.refreshSelectPickers();

      $('#txtLaunchDate').datepicker({
        uiLibrary: 'bootstrap4',
        format: 'dd/mm/yyyy'
      });
      $('#txtCompletionDate').datepicker({
        uiLibrary: 'bootstrap4',
        format: 'dd/mm/yyyy'
      });
    }, 100);
  }

  HideVentureAdd() {
    this.isVentureView = true;
    this.scrollToSearchSection();
    this.ventureForm.reset();
  }

  doUploadImage() {
    document.getElementById('propertyFiles')?.click();
  }

  VentureFiles_change(event: any): void {
    try {
      if (this.uploadFileTitle == '' || this.uploadFileType == '') {
        this.ventureCommon.CallToster('E', 'Please enter file title and select file type to upload.');
        return;
      }
      var fileInfo = {
        FileName: '',
        FileType: '',
        ContentType: this.uploadFileType,
        Label: this.uploadFileTitle,
        isVideo: false,
        isImage: false,
        isDocument: false,
        isResources: false
      }
      const file = event.target.files[0];
      const ext = file.name.split('.').pop().toLowerCase();


      if (this.uploadFileType == 'VentureLogo' && this.Resources.find(e => e.ContentType == 'VentureLogo')) {
        this.ventureCommon.CallToster('E', 'Venture Logo already exists, Please remove the exiting file and upload again.');
        return;
      }
      if (this.uploadFileType == 'VentureBrochure' && this.Resources.find(e => e.ContentType == 'VentureBrochure')) {
        this.ventureCommon.CallToster('E', 'Venture Brochure already exists, Please remove the exiting file and upload again.');
        return;
      }

      if ((this.uploadFileType == 'VentureVideos' || this.uploadFileType == 'WalkthroughVideo') && this.Resources.find(e => e.ContentType == this.uploadFileType)) {
        this.ventureCommon.CallToster('E', `${this.uploadFileTitle} already exists, Please remove the existing file and upload again.`);
        return;
      }

      if (this.uploadFileType == 'VentureVideos' || this.uploadFileType == 'WalkthroughVideo') {
        if (['mp4'].includes(ext)) {
          if (file.size > 10097152) {
            this.ventureCommon.CallToster('E', 'Video size exceeds 10 MB. Please upload a smaller video.');
            return;
          }
          fileInfo.isVideo = true;
          fileInfo.FileType = 'Video';
          this.uploadImage(file, fileInfo);
        }
        else {
          this.ventureCommon.CallToster('E', 'Invalid file format. Please upload an MP4 Video only.');
          return;
        }
      }
      else if (this.uploadFileType == 'VentureLogo' || this.uploadFileType == 'VentureImages') {
        if (['gif', 'png', 'jpg', 'jpeg'].includes(ext)) {
          if (file.size > 2097152) {
            this.ventureCommon.CallToster('E', 'Image size exceeds 2 MB. Please upload a smaller image.');
            return;
          }
          fileInfo.isImage = true;
          fileInfo.FileType = 'Image';
          this.uploadImage(file, fileInfo);
        }
        else {
          this.ventureCommon.CallToster('E', 'Invalid file format. Please upload an image only.');
          return;
        }
      }
      else if (this.uploadFileType == 'VentureBrochure' || this.uploadFileType == 'VenturePlan' || this.uploadFileType == 'UnitPlan') {
        if (['gif', 'png', 'jpg', 'jpeg', 'pdf'].includes(ext)) {
          if (file.size > 2097152) {
            this.ventureCommon.CallToster('E', 'Image size exceeds 2 MB. Please upload a smaller image.');
            return;
          }
          fileInfo.isImage = true;
          fileInfo.FileType = ext == 'pdf' ? 'PDF' : 'Image';
          this.uploadImage(file, fileInfo);
        }
        else {
          this.ventureCommon.CallToster('E', 'Invalid file format. Please upload an image or PDF');
          return;
        }
      }
      else {
        this.ventureCommon.CallToster('E', 'Invalid file type. Please select proper file type to upload.');
      }
    } catch (error) {
      this.isLoader = false;
      this.ventureCommon.CallToster('E', 'Something went wrong while uploading the file. Please try again later.');
    }
  }



  // Add this method to handle conditional validation
  private updateValidatorsBasedOnPropertyType() {
    const propertyType = this.ventureForm.controls['Property_Type'].value;

    if (propertyType === 3) { // Land
      // Remove validators for non-applicable fields
      this.ventureForm.controls['Blocks'].clearValidators();
      this.ventureForm.controls['NumberOfFloors'].clearValidators();
      this.ventureForm.controls['Blocks'].updateValueAndValidity();
      this.ventureForm.controls['NumberOfFloors'].updateValueAndValidity();
    } else {
      // Add validators back for Residential/Commercial
      this.ventureForm.controls['Blocks'].setValidators([Validators.required]);
      this.ventureForm.controls['NumberOfFloors'].setValidators([Validators.required]);
      this.ventureForm.controls['Blocks'].updateValueAndValidity();
      this.ventureForm.controls['NumberOfFloors'].updateValueAndValidity();
    }
  }

  // Call this in LoadSubPropertyByID
  LoadSubPropertyByID(typeId: number) {
    this.ventureForm.controls['Property_Type'].setValue(typeId);
    this.updateValidatorsBasedOnPropertyType();
  }



  private uploadImage(imageToUpload: File, FType: VentureResources): void {
    try {
      this.isLoader = true;
      const reader = new FileReader();
      const ext = imageToUpload.name.split('.').pop().toLowerCase();
      if (['gif', 'png', 'jpg', 'jpeg'].includes(ext)) {
        reader.onload = (e: any) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = 1024;
            canvas.height = 768;
            ctx.drawImage(img, 0, 0, 1024, 768);
            canvas.toBlob((blob) => {
              const formData = new FormData();
              formData.append('Image', blob, imageToUpload.name);
              this.uploadToServer(formData, FType);
            }, 'image/jpeg', 0.8);
          };
        };
        reader.readAsDataURL(imageToUpload);
      }
      else {
        const formData = new FormData();
        formData.append('Image', imageToUpload, imageToUpload.name);
        this.uploadToServer(formData, FType);
      }
    } catch (error) {
      this.isLoader = false;
      this.ventureCommon.CallToster('E', 'Unable to upload image, Please try again later...!');
    }
  }

  private uploadToServer(formData: FormData, FType: VentureResources) {
    this.ventureService.UploadImage(formData, 'VenturePics').subscribe(
      (res) => {
        this.isLoader = false;
        if (!res.isError && res.status === 1) {
          this.uploadFileType = '';
          this.uploadFileTitle = '';

          // âœ… FIX: Store the FULL URL from API response
          const fullImageUrl = res.body;  // "https://uatapi.buyrentsale.com/Uploads/VenturePics/20260518172619.png"

          console.log('Upload successful - Full URL:', fullImageUrl);  // Debug log

          FType.FileName = fullImageUrl;  // Store full URL, not just filename

          if (FType.ContentType == 'VentureLogo') {
            this.ventureForm.controls['Project_Logo'].setValue(fullImageUrl);
          } else if (FType.ContentType == 'VentureBrochure') {
            this.ventureForm.controls['Project_Brochure'].setValue(fullImageUrl);
          } else {
            FType.isResources = true;
          }
          this.Resources.push(FType);
        } else {
          this.ventureCommon.CallToster('E', 'Unable to upload file, Please try again later...!');
        }
      },
      (err) => {
        this.isLoader = false;
        this.ventureCommon.CallToster('E', 'Unable to upload file, Please try again later...!');
      }
    );
  }

  private normalizeImageUrl(url: string): string {
    if (!url) return '';

    // If it's already a full URL, return as is
    if (url.startsWith('http')) {
      return url;
    }

    // If it's just a filename (for backward compatibility), construct full URL
    // Use the appropriate environment URL
    return `${environment.apiUrl}Uploads/VenturePics/${url}`;
  }

  removeUploadedImg(rmIndex: number, type: string): void {
    const delResource = this.Resources[rmIndex];
    const fullPath = delResource?.FileName;

    if (fullPath) {
      const fileName = fullPath.split('/').pop();
      if (fileName) {
        this.postUsersService.deleteFile(fileName).subscribe(
          () => {
            this.Resources.splice(rmIndex, 1);
            if (delResource.ContentType == 'VentureLogo') {
              this.ventureForm.controls['Project_Logo'].setValue('');
            } else if (delResource.ContentType == 'VentureBrochure') {
              this.ventureForm.controls['Project_Brochure'].setValue('');
            } else if (delResource.ContentType == 'VenturePlan') {
              this.ventureForm.controls['ProjectVenture_Plan'].setValue('');
            }
          },
          (error) => {
            console.error(`Failed to delete file '${fileName}':`, error);
          }
        );
      } else {
        console.error('Failed to extract the file name from the path:', fullPath);
      }
    } else {
      console.error('imgPath does not exist for the given index:', rmIndex);
    }
  }

  viewUploadedVideo(filePath: string) {
    this.videoPath = filePath;
    setTimeout(() => {
      $('#viewVideoModal').modal('show');
    }, 500);
  }

  isVideo(media: string): boolean {
    return media.endsWith('.mp4') || media.endsWith('.avi') || media.endsWith('.mov');
  }

  isVideoAvailable(media: string): boolean {
    return media && !media.includes('coming_soon');
  }

  async checkVideoAvailability(videoUrl: string): Promise<boolean> {
    try {
      await this.http.head(videoUrl).toPromise();
      return true;
    } catch (error) {
      return false;
    }
  }

  async updateVideoPaths(userPostData: any): Promise<void> {
    for (const property of [...userPostData.Rent, ...userPostData.Sale]) {
      for (let i = 0; i < property.imgsList.length; i++) {
        const media = property.imgsList[i];
        if (this.isVideo(media)) {
          await this.updateVideoPath(property, media);
        }
      }
    }
  }

  async updateVideoPath(property: any, videoPath: string): Promise<void> {
    const index = property.imgsList.findIndex(media => media === videoPath);
    if (index !== -1) {
      const isAvailable = await this.checkVideoAvailability(videoPath);
      if (isAvailable) {
        property.imgsList[index] = videoPath;
      } else {
        property.imgsList[index] = 'assets/images/coming_soon.jpg';
      }
    }
  }

  playVideo(videoElement: HTMLVideoElement, requestId: number): void {
    videoElement.play();
    $('#carouselExampleControls' + requestId).carousel('pause');
  }

  stopVideo(videoElement: HTMLVideoElement, requestId: number): void {
    videoElement.pause();
    videoElement.currentTime = 0;
    $('#carouselExampleControls' + requestId).carousel('cycle');
  }

  toggleFullScreen(videoElement: HTMLVideoElement): void {
    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    }
  }

  private async EnableVentureViewMap(): Promise<void> {
    if (this.mapViewIds.length > 0) {
      for (const venture of this.mapViewIds) {
        var divId = 'ventureViewmap' + venture.ProjectID;
        if (!google || !google.maps) {
          console.error('Google Maps API is not loaded.');
          return;
        }
        const lat = venture.Latitude;
        const lng = venture.Longitude;
        const center = new google.maps.LatLng(lat, lng);

        const mapDiv = document.getElementById(divId);
        if (!mapDiv) {
          continue;
        }

        mapDiv.style.display = 'block';
        mapDiv.style.height = '250px';
        mapDiv.style.width = '100%';

        // Create map with explicit marker
        const mapOptions = {
          center: center,
          zoom: 15,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        const map = new google.maps.Map(mapDiv, mapOptions);

        // Add marker at the exact location with a custom icon
        const marker = new google.maps.Marker({
          position: center,
          map: map,
          title: 'Project Location',
          icon: {
            url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
            scaledSize: new google.maps.Size(40, 40),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 40)
          },
          animation: google.maps.Animation.DROP
        });

        // Add info window
        const infoWindow = new google.maps.InfoWindow({
          content: '<div style="padding:5px;"><strong>' + (venture.ProjectName || 'Project Location') + '</strong><br>ðŸ“ Exact Location</div>'
        });

        marker.addListener('click', () => {
          infoWindow.open(map, marker);
        });

        // Store reference
        this.markers.push(marker);

        // Initialize street view separately
        this.initMapStreetViewForPDF(venture, center);

        // *** ADD THIS: Find the parent wrapper and attach click event ***
        const wrapperDiv = mapDiv.closest('.mapViewWrapper') as HTMLElement;
        if (wrapperDiv) {
          // Remove any existing click listener to avoid duplicates
          wrapperDiv.style.cursor = 'pointer';

          // Add click event to open full map
          wrapperDiv.onclick = (event) => {
            event.stopPropagation();
            // Find the venture data for this map
            const ventureData = this.ventureList.find(v => v.ProjectID === venture.ProjectID);
            if (ventureData) {
              this.openFullMapView(ventureData);
            }
          };
        }
      }
    }
  }

  private initMapStreetViewForPDF(mapView: any, center: google.maps.LatLng): void {
    if (!google || !google.maps) {
      return;
    }

    var divId = 'street-view' + mapView.ProjectID;
    const streetViewDiv = document.getElementById(divId);

    if (!streetViewDiv) {
      setTimeout(() => {
        this.initMapStreetViewForPDF(mapView, center);
      }, 100);
      return;
    }

    streetViewDiv.style.display = 'block';
    streetViewDiv.style.height = '250px';
    streetViewDiv.style.width = '100%';
    streetViewDiv.style.backgroundColor = '#f0f0f0';

    // Check if street view is available
    const streetViewService = new google.maps.StreetViewService();

    streetViewService.getPanorama({ location: center, radius: 100 }, (data, status) => {
      if (status === google.maps.StreetViewStatus.OK) {
        const panorama = new google.maps.StreetViewPanorama(streetViewDiv, {
          position: center,
          pov: {
            heading: 34,
            pitch: 10
          },
          zoom: 1,
          addressControl: false,
          showRoadLabels: false,
          motionTracking: false,
          visible: true
        });
      } else {
        streetViewDiv.innerHTML = `
                <div style="text-align:center; padding:50px; color:#666;">
                    <i class="fas fa-map-marked-alt" style="font-size: 40px; margin-bottom: 10px; display: block;"></i>
                    Street View not available for this location
                </div>
            `;
      }
    });
  }

  initMapStreetView(mapView: any): void {
    if (!google || !google.maps) {
      console.error('Google Maps API is not loaded.');
      return;
    }

    const lat = parseFloat(mapView.Latitude);
    const lng = parseFloat(mapView.Longitude);
    const center = new google.maps.LatLng(lat, lng);

    var divId = 'street-view' + mapView.ProjectID;
    const streetViewDiv = document.getElementById(divId);

    if (!streetViewDiv) {
      setTimeout(() => {
        this.initMapStreetView(mapView);
      }, 100);
      return;
    }

    streetViewDiv.style.display = 'block';
    streetViewDiv.style.backgroundColor = '#f0f0f0';
    streetViewDiv.innerHTML = '<div style="text-align:center; padding:50px;">Loading Street View...</div>';

    const streetViewService = new google.maps.StreetViewService();

    streetViewService.getPanorama({ location: center, radius: 50 }, (data, status) => {
      if (status === google.maps.StreetViewStatus.OK) {
        const panorama = new google.maps.StreetViewPanorama(streetViewDiv, {
          position: center,
          pov: {
            heading: 34,
            pitch: 10
          },
          zoom: 1,
          addressControl: false,
          showRoadLabels: false,
          motionTracking: false,
          motionTrackingControl: false,
          visible: true
        });
        if (this.map) {
          this.map.setStreetView(panorama);
        }
        if (streetViewDiv.firstChild && streetViewDiv.firstChild.nodeType === Node.TEXT_NODE) {
          streetViewDiv.innerHTML = '';
        }
      } else {
        streetViewDiv.innerHTML = `
          <div style="text-align:center; padding:50px; color:#666;">
            <i class="fas fa-map-marked-alt" style="font-size: 40px; margin-bottom: 10px; display: block;"></i>
            Street View not available for this location
          </div>
        `;
        console.warn('Street View not available for:', center);
      }
    });
  }

  clearMarkers(): void {
    for (const marker of this.markers) {
      marker.setMap(null);
    }
    this.markers = [];
  }

  doRateYourSelf(pId: number): void {
    if (this.authData == undefined || this.authData == null || this.authData.UserID == undefined || this.authData.UserID == null) {
      this.ventureCommon.CallToster('W', 'Please login to save your venture details');
      return;
    }
    $('#rateYourSelfModal').modal('show');
    this.EntityID = pId;
  }

  doSaveRating(): void {
    this.selected_rating = $('#selected_rating').val();
    if (this.reviewText.trim() === '') {
      this.ventureCommon.CallToster('W', 'Please enter your review text.');
      return;
    }
    if (this.selected_rating === '' || this.selected_rating === undefined) {
      this.ventureCommon.CallToster('W', 'Please select a rating.');
      return;
    }
    const ratingData = {
      EntityType: "Project",
      EntityID: this.EntityID,
      MemberID: this.authData?.UserID,
      Rating: parseInt(this.selected_rating),
      Comments: this.reviewText
    };
    this.isLoader = true;
    this.ventureService.SaveRating(ratingData).subscribe((res) => {
      this.isLoader = false;
      if (res.status === 1) {
        this.ventureCommon.CallToster('S', 'Your rating has been saved successfully.');
        this.reviewText = '';
        this.selected_rating = '';
        $('#rateYourSelfModal').modal('hide');
      } else {
        this.ventureCommon.CallToster('W', 'Unable to save your rating, Please try later.');
      }
    }, (err) => {
      this.isLoader = false;
      this.ventureCommon.CallToster('W', 'Something went wrong, Please try later');
    });
  }

  onResourceTypeChange(event: any): void {
    const selectedValue = event.target.value;

    if (selectedValue === '') {
      this.uploadFileTitle = '';
      this.uploadFileAcceptTypes = 'image/jpeg, image/jpg, image/png';
    } else {
      const selectedType = this.resourceTypes.find(type => type.value === selectedValue);
      if (selectedType) {
        this.uploadFileTitle = selectedType.text;
        switch (selectedValue) {
          case 'VentureBrochure':
          case 'UnitPlan':
            this.uploadFileAcceptTypes = 'image/jpeg, image/jpg, image/png, application/pdf';
            break;
          case 'VentureVideos':
          case 'WalkthroughVideo':
            this.uploadFileAcceptTypes = 'video/mp4';
            break;
          default:
            this.uploadFileAcceptTypes = 'image/jpeg, image/jpg, image/png';
            break;
        }
      }
    }
  }

  allowDrop(event: DragEvent): void {
    event.preventDefault();
  }

  handleDropResource(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileEvent = { target: { files } } as any;
      this.VentureFiles_change(fileEvent);
    }
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  isImage(fileName: string): boolean {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName);
  }

  isPDF(fileName: string): boolean {
    return /\.pdf$/i.test(fileName);
  }

  showEditPage(venture: any): void {
    try {
      this.isVentureView = false;
      this.Resources = [];

      // âœ… Normalize URLs
      const normalizedLogo = this.normalizeImageUrl(venture.Project_Logo);
      const normalizedBrochure = this.normalizeImageUrl(venture.Project_Brochure);

      // âœ… Also normalize resources if they exist
      let normalizedResources = [];
      if (venture.ProjectResources_JSON && venture.ProjectResources_JSON.length > 0) {
        normalizedResources = venture.ProjectResources_JSON.map(resource => ({
          ...resource,
          FileName: this.normalizeImageUrl(resource.FileName)
        }));
      }

      setTimeout(() => {
        $('.rdbcategory-type').removeAttr('checked');
        this.Resources = normalizedResources;  // âœ… Use normalized resources

        this.ventureForm.patchValue({
          ProjectID: venture.ProjectID,
          ProjectOrVentureName: venture.ProjectOrVentureName,
          ProjectOrVentureID: venture.ProjectOrVentureID,
          Developer_Name: venture.Developer_Name,
          AreaID: venture.AreaID,
          Property_Type: venture.Property_Type == PropertyType.Residential ? 1 : venture.Property_Type == PropertyType.Commercial ? 2 : 3,
          Amenities: venture.Amenities.toString().split(',').map(Number),
          UnitId: venture.UnitId,
          UnitMeasures: parseFloat(venture.Project_Measure),
          Open_Space: venture.Open_Space.toString().replace('%', ''),
          Blocks: venture.Blocks,
          NumberOfFloors: venture.NumberOfFloors,
          NumberOfUnitsOrPlots: venture.NumberOfUnitsOrPlots,
          TypesOfUnits: venture.TypesOfUnits,
          PricingDetails: venture.PricingDetails,
          ProjectStatus: venture.ProjectStatus,
          LaunchDate: this.formatDateForPicker(venture.LaunchDate),
          CompletionDate: this.formatDateForPicker(venture.CompletionDate),
          LegalApprovals: venture.LegalApprovals,
          Project_Logo: normalizedLogo,        // âœ… Use normalized
          Project_Brochure: normalizedBrochure, // âœ… Use normalized
          ProjectVenture_Plan: venture.ProjectVenture_Plan,
          Overview: venture.Overview,
          UserID: venture.UserID,
          Status: venture.Status,
          Latitude: venture.Latitude,
          Longitude: venture.Longitude
        });

        if (this.ventureForm.controls['Property_Type'].value == 1) {
          $('#rdbProperty-type-1').trigger('click');
        } else if (this.ventureForm.controls['Property_Type'].value == 2) {
          $('#rdbProperty-type-2').trigger('click');
        } else {
          $('#rdbProperty-type-3').trigger('click');
        }

        this.initSelectPickers();
        this.refreshSelectPickers();
        this.updateAddress(parseFloat(venture.Latitude), parseFloat(venture.Longitude));
        this.initMap();
        this.showMap = true;

        // âœ… Use normalized URLs here too!
        this.Resources.push({
          ContentType: 'VentureLogo',
          FileName: normalizedLogo,           // âœ… Changed from venture.Project_Logo
          FileType: 'Image',
          Label: 'Venture Logo',
          isVideo: false,
          isImage: true,
          isDocument: false,
          isResources: false
        });

        this.Resources.push({
          ContentType: 'VentureBrochure',
          FileName: normalizedBrochure,       // âœ… Changed from venture.Project_Brochure
          FileType: this.isPDF(normalizedBrochure) ? 'PDF' : 'Image',  // âœ… Use normalized
          Label: 'Venture Brochure',
          isVideo: false,
          isImage: false,
          isDocument: true,
          isResources: false
        });

        // âœ… Also add VenturePlan if exists with normalized URL
        if (venture.ProjectVenture_Plan && venture.ProjectVenture_Plan.FileName) {
          this.Resources.push({
            ContentType: 'VenturePlan',
            FileName: this.normalizeImageUrl(venture.ProjectVenture_Plan.FileName),
            FileType: 'Image',
            Label: 'Venture Plan',
            isVideo: false,
            isImage: true,
            isDocument: false,
            isResources: true
          });
        }

      }, 500);

      setTimeout(() => {
        this.scrollToSearchSection();
        $('#txtLaunchDate').datepicker({
          uiLibrary: 'bootstrap4',
          format: 'dd/mm/yyyy',
          value: this.ventureForm.controls['LaunchDate'].value
        });
        $('#txtCompletionDate').datepicker({
          uiLibrary: 'bootstrap4',
          format: 'dd/mm/yyyy',
          value: this.ventureForm.controls['CompletionDate'].value
        });
      }, 1000);
    } catch (error) {
      console.error('Error in showEditPage:', error);
    }
  }

  private formatDateForPicker(date: any): string {
    if (!date) return '';
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) return date;
    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  scrollToSearchSection() {
    const element = document.getElementById('main-venture-div');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  ngAfterViewInit(): void {
    this.initSelectPickers();
    this.scheduleSelectPickerInitRetries();

    this.cdr.detectChanges();
    setTimeout(() => {
      this.setupAutocomplete();
    }, 500);
  }

  ngOnDestroy(): void {
    this.selectPickerTimerIds.forEach(timerId => clearTimeout(timerId));
    this.selectPickerTimerIds = [];
  }

  private initSelectPickers(): void {
    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        if (!window['$'] || !window['$'].fn || !window['$'].fn.selectpicker) {
          return;
        }
        $('.selectpicker').each(function () {
          const $select = $(this);
          if (!$select.length) return;
          try { $select.selectpicker('destroy'); } catch (e) { }
          $select.selectpicker({ container: '.venture-list-add' });
          $select.selectpicker('refresh');
        });
      });
    }, 0);
  }

  private refreshSelectPickers(): void {
    setTimeout(() => {
      if (!window['$'] || !window['$'].fn || !window['$'].fn.selectpicker) {
        return;
      }
      $('.selectpicker').each(function () {
        const $select = $(this);
        if (!$select.length) return;
        try { $select.selectpicker('refresh'); } catch (e) { }
      });
    }, 0);
  }

  private scheduleSelectPickerInitRetries(): void {
    [300, 1000, 2500].forEach(delayMs => {
      const timerId = setTimeout(() => this.initSelectPickers(), delayMs);
      this.selectPickerTimerIds.push(timerId);
    });
  }

  get filteredAreas(): any[] {
    if (!this.areaSearch || !this.areasList || this.areasList.length === 0) {
      return this.areasList || [];
    }
    const filterText = this.areaSearch.toLowerCase();
    return this.areasList.filter(area => area.AreaName?.toLowerCase().includes(filterText));
  }

  onAmenityChange(event: any, amenityId: number): void {
    const checked = event.target.checked;
    const currentAmenities = this.ventureForm.controls['Amenities'].value || [];
    if (checked) {
      if (!currentAmenities.includes(amenityId)) {
        currentAmenities.push(amenityId);
      }
    } else {
      const index = currentAmenities.indexOf(amenityId);
      if (index > -1) {
        currentAmenities.splice(index, 1);
      }
    }
    this.ventureForm.controls['Amenities'].setValue(currentAmenities);
  }

  isAmenitySelected(amenityId: number): boolean {
    const currentAmenities = this.ventureForm.controls['Amenities'].value || [];
    return currentAmenities.includes(amenityId);
  }

  toggleDropdown(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const dropdown = document.getElementById('amenitiesDropdown');
    const menu = document.getElementById('amenitiesDropdownMenu');
    if (dropdown && menu && !dropdown.contains(target) && !menu.contains(target)) {
      this.isDropdownOpen = false;
    }
    const areaDropdown = document.getElementById('areaDropdown');
    const areaMenu = document.getElementById('areaDropdownMenu');
    if (areaDropdown && areaMenu && !areaDropdown.contains(target) && !areaMenu.contains(target)) {
      this.isAreaDropdownOpen = false;
    }
  }

  toggleAreaDropdown(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.isAreaDropdownOpen = !this.isAreaDropdownOpen;
  }

  onAreaSearchChange(): void {
    this.isAreaDropdownOpen = true;
  }

  selectArea(area: any): void {
    this.ventureForm.controls['AreaID'].setValue(area.AreaID);
    this.selectedAreaId = area.AreaID;
    this.isAreaDropdownOpen = false;
    this.areaSearch = area.AreaName;
  }

  clearAreaSelection(): void {
    this.ventureForm.controls['AreaID'].setValue('');
    this.selectedAreaId = null;
    this.areaSearch = '';
    this.isAreaDropdownOpen = false;
  }

  getSelectedAreaName(): string {
    const selectedId = this.ventureForm.controls['AreaID'].value;
    const selectedArea = this.areasList.find(area => area.AreaID == selectedId);
    return selectedArea ? selectedArea.AreaName : '';
  }

  // ==================== PDF DOWNLOAD METHODS ====================

  shareVenture(venture: any): void {
    const url = `${environment.apiUrl}/m/venture-details?ventureid=${venture.ProjectID}`;
    const shareData = {
      title: `Buy Rent Sale - ${venture.ProjectOrVentureName}`,
      text: `Check out this amazing venture: ${venture.ProjectOrVentureName} in ${venture.AreaName}. For more details visit BuyRentSale.com`,
      url: url,
    };
    if ((navigator as any).share) {
      (navigator as any).share(shareData)
        .then(() => console.log('Successfully shared'))
        .catch((error) => {
          console.error('Error sharing:', error);
          this.fallbackShare(url);
        });
    } else {
      this.fallbackShare(url);
    }
  }

  private fallbackShare(url: string): void {
    navigator.clipboard.writeText(url).then(() => {
      this.ventureCommon.CallToster('S', 'Venture link copied to clipboard!');
    }).catch(() => {
      this.ventureCommon.CallToster('E', 'Unable to share. Please try again.');
    });
  }

  async downloadVenture(venture: any): Promise<void> {
    if (this.pdfGenerationInProgress) {
      this.ventureCommon.CallToster('W', 'PDF generation already in progress. Please wait...');
      return;
    }

    this.pdfGenerationInProgress = true;
    this.isLoader = true;
    this.updateLoaderProgress(0, 'Starting PDF generation...');
    this.cdr.detectChanges();
    await this.delay(50);

    try {
      this.updateLoaderProgress(30, 'ðŸ“‹ Capturing venture details...');
      await this.delay(30);

      this.updateLoaderProgress(60, 'ðŸ“„ Generating PDF...');
      await this.delay(30);

      await this.generatePDF(venture);

      this.updateLoaderProgress(100, 'âœ… Complete!');
      this.ventureCommon.CallToster('S', 'Venture details downloaded successfully!');

    } catch (error) {
      console.error('Error generating PDF:', error);
      this.ventureCommon.CallToster('E', 'Failed to download venture details');
    } finally {
      setTimeout(() => {
        this.isLoader = false;
        this.pdfGenerationInProgress = false;
        this.cdr.detectChanges();
      }, 500);
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private updateLoaderProgress(percent: number, message: string): void {
    this.ngZone.run(() => {
      const progressBar = document.querySelector('.progress-bar-fill') as HTMLElement;
      if (progressBar) {
        progressBar.style.width = `${percent}%`;
      }
      const loaderText = document.querySelector('.loader-text');
      if (loaderText) {
        loaderText.textContent = message;
      }
      const percentText = document.querySelector('.loader-percent');
      if (percentText) {
        percentText.textContent = `${percent}%`;
      }
      this.cdr.detectChanges();
    });
  }

  private storeOriginalStyles(element: HTMLElement): any {
    return {
      overflow: element.style.overflow,
      height: element.style.height,
      position: element.style.position
    };
  }

  private applyCaptureStyles(element: HTMLElement): void {
    element.style.overflow = 'visible';
    element.style.height = 'auto';
    element.style.position = 'relative';
  }

  private restoreOriginalStyles(element: HTMLElement, styles: any): void {
    element.style.overflow = styles.overflow;
    element.style.height = styles.height;
    element.style.position = styles.position;
  }

  private async waitForImagesFast(element: HTMLElement, timeoutMs: number): Promise<void> {
    const images = Array.from(element.getElementsByTagName('img'));
    const totalImages = images.length;

    if (totalImages === 0) {
      this.updateLoaderProgress(50, 'âœ“ No images to load');
      return;
    }

    let loadedCount = 0;

    const imagePromises = images.map((img) => {
      return new Promise<void>((resolve) => {
        if (img.complete && img.naturalHeight !== 0) {
          loadedCount++;
          const percent = 30 + Math.round((loadedCount / totalImages) * 30);
          this.updateLoaderProgress(percent, `ðŸ“¥ Loading resources ${loadedCount}/${totalImages}...`);
          resolve();
        } else {
          const onLoad = () => {
            loadedCount++;
            const percent = 30 + Math.round((loadedCount / totalImages) * 30);
            this.updateLoaderProgress(percent, `ðŸ“¥ Loading resources ${loadedCount}/${totalImages}...`);
            resolve();
          };
          const onError = () => {
            loadedCount++;
            const percent = 30 + Math.round((loadedCount / totalImages) * 30);
            this.updateLoaderProgress(percent, `ðŸ“¥ Loading resources ${loadedCount}/${totalImages}...`);
            resolve();
          };
          img.addEventListener('load', onLoad, { once: true });
          img.addEventListener('error', onError, { once: true });
        }
      });
    });

    await Promise.race([
      Promise.all(imagePromises),
      new Promise(resolve => setTimeout(resolve, timeoutMs))
    ]);
  }


  async capturePDFMapImage(venture: any): Promise<string> {
    return new Promise((resolve) => {
      const mapDiv = document.createElement('div');
      mapDiv.style.width = '800px';
      mapDiv.style.height = '400px';
      mapDiv.style.position = 'absolute';
      mapDiv.style.left = '-9999px';
      mapDiv.style.top = '-9999px';
      document.body.appendChild(mapDiv);

      const lat = parseFloat(venture.Latitude);
      const lng = parseFloat(venture.Longitude);
      const center = new google.maps.LatLng(lat, lng);

      const mapOptions = {
        center: center,
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        styles: [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }]
          }
        ]
      };

      const tempMap = new google.maps.Map(mapDiv, mapOptions);

      new google.maps.Marker({
        position: center,
        map: tempMap,
        title: venture.ProjectOrVentureName,
        animation: google.maps.Animation.DROP,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
          scaledSize: new google.maps.Size(40, 40)
        }
      });

      // Add a delay to ensure map renders fully
      setTimeout(() => {
        html2canvas(mapDiv, {
          useCORS: true,
          scale: 3, // Higher scale for better quality
          backgroundColor: '#ffffff',
          logging: false,
          windowWidth: mapDiv.scrollWidth,
          windowHeight: mapDiv.scrollHeight
        }).then(canvas => {
          const imageData = canvas.toDataURL('image/png');
          document.body.removeChild(mapDiv);
          resolve(imageData);
        }).catch(() => {
          document.body.removeChild(mapDiv);
          resolve('');
        });
      }, 2500);
    });
  }


  private async generatePDF(venture: any): Promise<void> {
    return new Promise(async (resolve) => {
      const element = document.getElementById(`venture-info-${venture.ProjectID}`);
      if (!element) {
        this.ventureCommon.CallToster('E', 'Unable to capture venture details');
        resolve();
        return;
      }

      this.updateLoaderProgress(40, 'ðŸ—ºï¸ Capturing map location...');
      let mapImageData = '';
      if (venture.Latitude && venture.Longitude && venture.Latitude !== '' && venture.Longitude !== '') {
        mapImageData = await this.captureMapForPDF(venture);
        console.log('Map captured:', mapImageData ? 'Yes' : 'No');
      }

      // Create a clone of the element to modify for PDF
      const cloneElement = element.cloneNode(true) as HTMLElement;

      // Remove the right sidebar completely (web-only elements)
      const rightSidebar = cloneElement.querySelector('.col-sm-3.pad10L.pad10R');
      if (rightSidebar) {
        rightSidebar.remove();
      }

      // Make left column full width
      const leftColumn = cloneElement.querySelector('.col-sm-9');
      if (leftColumn) {
        leftColumn.classList.remove('col-sm-9');
        leftColumn.classList.add('col-sm-12');
        (leftColumn as HTMLElement).style.width = '100%';
        (leftColumn as HTMLElement).style.maxWidth = '100%';
      }

      // ðŸ”¥ NEW: Make all tab content visible for PDF
      const tabContainer = cloneElement.querySelector('.analysis-tabs-container');
      if (tabContainer) {
        // Show ALL tab panes
        const allTabPanes = tabContainer.querySelectorAll('.tab-pane');
        allTabPanes.forEach(pane => {
          pane.classList.add('show', 'active');
          (pane as HTMLElement).style.display = 'block';
        });

        // Hide the tab headers (navigation)
        const tabHeaders = tabContainer.querySelector('.nav-tabs');
        if (tabHeaders) {
          (tabHeaders as HTMLElement).style.display = 'none';
        }

        // Add a separator between sections in PDF
        const separator = document.createElement('hr');
        separator.style.margin = '30px 0';
        separator.style.borderTop = '2px solid #00B98E';

        // Insert separators between tab contents
        const tabContent = tabContainer.querySelector('.tab-content');
        if (tabContent) {
          const panes = tabContent.querySelectorAll('.tab-pane');
          for (let i = 0; i < panes.length; i++) {
            if (i < panes.length - 1) {
              const separatorClone = separator.cloneNode(true);
              panes[i].parentNode?.insertBefore(separatorClone, panes[i].nextSibling);
            }
          }
        }
      }

      // Apply print styles to clone
      cloneElement.style.width = '100%';
      cloneElement.style.maxWidth = '100%';
      cloneElement.style.backgroundColor = '#ffffff';
      cloneElement.style.padding = '20px';

      // Temporarily append clone to capture
      cloneElement.style.position = 'absolute';
      cloneElement.style.left = '-9999px';
      cloneElement.style.top = '0';
      document.body.appendChild(cloneElement);

      // Capture the main content as image
      const canvas = await html2canvas(cloneElement, {
        useCORS: true,
        allowTaint: false,
        scale: 2,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: cloneElement.scrollWidth,
        windowHeight: cloneElement.scrollHeight
      });

      // Remove clone
      document.body.removeChild(cloneElement);

      const imgData = canvas.toDataURL('image/jpeg', 0.85);

      const margin = 5;
      const pdfWidth = 210;
      const imgWidth = pdfWidth - (margin * 2);
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Calculate map height if available
      let mapHeightMM = 0;
      if (mapImageData && mapImageData.length > 100) {
        await new Promise<void>((resolveMap) => {
          const tempImg = new Image();
          tempImg.onload = () => {
            const imgAspectRatio = tempImg.height / tempImg.width;
            mapHeightMM = imgWidth * imgAspectRatio;
            resolveMap();
          };
          tempImg.onerror = () => {
            mapHeightMM = 70;
            resolveMap();
          };
          tempImg.src = mapImageData;
        });
      }

      // Calculate QR code and footer space
      const qrHeight = 35;
      const footerHeight = 15;
      let pdfHeight = imgHeight + (mapImageData ? mapHeightMM + 5 : 0) + qrHeight + footerHeight + 10;
      if (pdfHeight < 250) pdfHeight = 250;

      const pdf = new jsPDF({
        unit: 'mm',
        format: [pdfWidth, pdfHeight],
        orientation: 'p',
        compress: true
      });

      let currentY = margin;

      // Add captured HTML content
      pdf.addImage(imgData, 'JPEG', margin, currentY, imgWidth, imgHeight);
      currentY += imgHeight + 3;

      // Add Map Image if available
      if (mapImageData && mapImageData.length > 100 && mapHeightMM > 0) {
        try {
          pdf.addImage(mapImageData, 'JPEG', margin, currentY, imgWidth, mapHeightMM, undefined, 'MEDIUM');
          currentY += mapHeightMM + 3;
        } catch (mapAddError) {
          console.error('Error adding map to PDF:', mapAddError);
        }
      }

      // Add QR Code at the bottom
      const ventureUrl = `https://uat.buyrentsale.com/w/viewprojects?projectId=${venture.ProjectID}`;
      QRCode.toDataURL(ventureUrl, { width: 150 }, (err, qrCodeData) => {
        if (!err && qrCodeData) {
          const qrSize = 28;
          const qrX = pdfWidth / 2 - qrSize / 2;
          pdf.addImage(qrCodeData, 'PNG', qrX, currentY, qrSize, qrSize);

          pdf.setFontSize(7);
          pdf.setTextColor(80, 80, 80);
          pdf.text("Scan for more details", pdfWidth / 2, currentY + qrSize + 3, { align: 'center' });

          const footerY = currentY + qrSize + 12;
          pdf.setFontSize(6);
          pdf.setTextColor(120, 120, 120);
          pdf.text("www.BuyRentSale.com", pdfWidth / 2, footerY, { align: 'center' });
          pdf.text("support@buyrentsale.com | 9618641100", pdfWidth / 2, footerY + 4, { align: 'center' });
        }

        const fileName = `${venture.ProjectOrVentureName.substring(0, 40).replace(/[^a-z0-9]/gi, '_')}.pdf`;
        pdf.save(fileName);
        resolve();
      });
    });
  }


  likeVenture(venture: any): void {
    if (!this.authData || !this.authData.UserID) {
      this.ventureCommon.CallToster('W', 'Please login to like this venture');
      return;
    }

    this.isLoader = true;
    this.ventureService.LikeVenture(venture.ProjectID, this.authData.UserID).subscribe(
      (res) => {
        this.isLoader = false;
        if (res.status === 1) {
          this.ventureCommon.CallToster('S', 'Venture added to your favorites');
        } else {
          this.ventureCommon.CallToster('E', res.message || 'Unable to like venture');
        }
      },
      (error) => {
        this.isLoader = false;
        this.ventureCommon.CallToster('E', 'Something went wrong');
      }
    );
  }


  InitVentureViewMap(venture: any): boolean {
    if (!venture?.Latitude || !venture?.Longitude || venture.Latitude === '' || venture.Longitude === '') {
      return false;
    }
    const lat = parseFloat(venture.Latitude);
    const lng = parseFloat(venture.Longitude);
    if (isNaN(lat) || isNaN(lng)) {
      return false;
    }
    // Add ProjectName for info window
    venture.ProjectName = venture.ProjectOrVentureName || venture.ProjectOrVentureName || 'Project Location';
    return true;
  }



  // Add this method to your VenturesComponent class
  openFullMapView(venture: any): void {
    if (!venture?.Latitude || !venture?.Longitude) {
      this.ventureCommon.CallToster('W', 'Map location not available');
      return;
    }

    // Store the venture data for the modal
    this.selectedVentureForMap = venture;

    // Show the modal
    $('#fullMapModal').modal('show');

    // Initialize the full map after modal is shown
    setTimeout(() => {
      this.initFullMapModal(venture);
    }, 500);
  }

  // Initialize the full map in modal
  initFullMapModal(venture: any): void {
    const modalMapDiv = document.getElementById('fullMapModalMap');
    if (!modalMapDiv) return;

    const lat = parseFloat(venture.Latitude);
    const lng = parseFloat(venture.Longitude);
    const center = new google.maps.LatLng(lat, lng);

    const mapOptions = {
      center: center,
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      fullscreenControl: true,
      streetViewControl: true,
      zoomControl: true,
      mapTypeControl: true
    };

    const fullMap = new google.maps.Map(modalMapDiv, mapOptions);

    // Add marker
    const marker = new google.maps.Marker({
      position: center,
      map: fullMap,
      title: venture.ProjectOrVentureName,
      icon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(25, 50)
      },
      animation: google.maps.Animation.DROP
    });

    // Add info window
    const infoWindow = new google.maps.InfoWindow({
      content: `
      <div style="padding: 10px;">
        <strong>${venture.ProjectOrVentureName}</strong><br>
        ${venture.AreaName || ''}<br>
        <a href="https://www.google.com/maps?q=${lat},${lng}" target="_blank">
          View on Google Maps
        </a>
      </div>
    `
    });

    marker.addListener('click', () => {
      infoWindow.open(fullMap, marker);
    });

    // Auto-open info window
    infoWindow.open(fullMap, marker);
  }


  async captureMapForPDF(venture: any): Promise<string> {
    return new Promise((resolve) => {
      try {
        // Find the existing map container for this venture
        const mapDivId = `ventureViewmap${venture.ProjectID}`;
        const existingMapDiv = document.getElementById(mapDivId);

        if (existingMapDiv && existingMapDiv.querySelector('.gm-style')) {
          console.log('Found existing map for venture', venture.ProjectID);

          // Get the actual map dimensions
          const mapRect = existingMapDiv.getBoundingClientRect();
          const originalWidth = mapRect.width;
          const originalHeight = mapRect.height;

          // Create a wrapper div with proper styling
          const wrapperDiv = document.createElement('div');
          wrapperDiv.style.width = `${originalWidth}px`;
          wrapperDiv.style.backgroundColor = '#ffffff';
          wrapperDiv.style.borderRadius = '8px';
          wrapperDiv.style.overflow = 'hidden';
          wrapperDiv.style.fontFamily = 'Arial, sans-serif';
          wrapperDiv.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';

          // Add heading with clean styling
          const heading = document.createElement('div');
          heading.style.padding = '8px 12px';
          heading.style.backgroundColor = '#f8f9fa';
          heading.style.borderBottom = '2px solid #00B98E';
          heading.style.fontSize = '12px';
          heading.style.fontWeight = '600';
          heading.style.color = '#333';
          heading.innerHTML = `ðŸ“ PROJECT LOCATION`;
          wrapperDiv.appendChild(heading);

          // Clone the map container
          const cloneMapDiv = existingMapDiv.cloneNode(true) as HTMLElement;
          cloneMapDiv.style.width = `${originalWidth}px`;
          cloneMapDiv.style.height = `${originalHeight}px`;
          cloneMapDiv.style.position = 'relative';
          cloneMapDiv.style.backgroundColor = '#e8e8e8';

          wrapperDiv.appendChild(cloneMapDiv);

          // Add coordinates with clean styling
          const lat = parseFloat(venture.Latitude);
          const lng = parseFloat(venture.Longitude);
          const coordsText = document.createElement('div');
          coordsText.style.padding = '6px 12px';
          coordsText.style.backgroundColor = '#f8f9fa';
          coordsText.style.fontSize = '10px';
          coordsText.style.color = '#666';
          coordsText.style.borderTop = '1px solid #e0e0e0';
          coordsText.style.textAlign = 'center';
          coordsText.innerHTML = `ðŸ“ Coordinates: ${lat.toFixed(6)}Â° N, ${lng.toFixed(6)}Â° E`;
          wrapperDiv.appendChild(coordsText);

          wrapperDiv.style.position = 'absolute';
          wrapperDiv.style.left = '-9999px';
          wrapperDiv.style.top = '-9999px';
          document.body.appendChild(wrapperDiv);

          // Capture the wrapper
          setTimeout(() => {
            html2canvas(wrapperDiv, {
              useCORS: true,
              scale: 2,
              backgroundColor: '#ffffff',
              logging: false,
              allowTaint: false
            }).then(canvas => {
              const imageData = canvas.toDataURL('image/jpeg', 0.95);
              document.body.removeChild(wrapperDiv);
              console.log('Map captured successfully');
              resolve(imageData);
            }).catch(err => {
              console.error('Error capturing map:', err);
              document.body.removeChild(wrapperDiv);
              resolve('');
            });
          }, 500);
        } else {
          console.log('No map element found for venture', venture.ProjectID);
          resolve('');
        }
      } catch (error) {
        console.error('captureMapForPDF error:', error);
        resolve('');
      }
    });
  }

  // Add this method to your VenturesComponent class
  openInGoogleMaps(): void {
    if (this.selectedVentureForMap?.Latitude && this.selectedVentureForMap?.Longitude) {
      const url = `https://www.google.com/maps?q=${this.selectedVentureForMap.Latitude},${this.selectedVentureForMap.Longitude}`;
      window.open(url, '_blank');
    }
  }


  getWalkthroughVideo(project: any): any {
    if (project?.ProjectResources_JSON && project.ProjectResources_JSON.length > 0) {
      return project.ProjectResources_JSON.find(r => r.ContentType === 'WalkthroughVideo');
    }
    return null;
  }



  // Normalize social media URLs before sending to API
  normalizeSocialMediaUrls(postData: any): any {
    // Normalize YouTube
    if (postData.YouTubeUrl) {
      postData.YouTubeUrl = this.normalizeYouTubeUrl(postData.YouTubeUrl);
    }

    // Normalize Facebook
    if (postData.FacebookUrl) {
      postData.FacebookUrl = this.normalizeFacebookUrl(postData.FacebookUrl);
    }

    // Normalize Instagram
    if (postData.InstagramUrl) {
      postData.InstagramUrl = this.normalizeInstagramUrl(postData.InstagramUrl);
    }

    // Normalize WhatsApp
    if (postData.Whatsapp) {
      postData.Whatsapp = this.normalizeWhatsApp(postData.Whatsapp);
    }

    // Normalize Telegram
    if (postData.Telegram) {
      postData.Telegram = this.normalizeTelegram(postData.Telegram);
    }

    return postData;
  }

  // YouTube URL normalization - FIXED VERSION
  normalizeYouTubeUrl(input: string): string {
    if (!input) return '';

    // Remove whitespace
    input = input.trim();

    // Extract channel ID, video ID, or handle
    let youtubeId = '';

    // Pattern for youtube.com URLs - FIXED to capture full handle
    // Handle @username format (channel handle)
    const atHandleRegex = /youtube\.com\/@([a-zA-Z0-9_.-]+)/i;
    const atHandleMatch = input.match(atHandleRegex);

    if (atHandleMatch) {
      // Return the handle with @ symbol
      youtubeId = `@${atHandleMatch[1]}`;
    }

    // Check for youtu.be format (video short URL)
    if (!youtubeId) {
      const youtuBeRegex = /youtu\.be\/([a-zA-Z0-9_-]+)/i;
      const youtuBeMatch = input.match(youtuBeRegex);
      if (youtuBeMatch) {
        youtubeId = youtuBeMatch[1];
      }
    }

    // Check for standard video URL
    if (!youtubeId) {
      const videoRegex = /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/i;
      const videoMatch = input.match(videoRegex);
      if (videoMatch) {
        youtubeId = videoMatch[1];
      }
    }

    // Check for embed URL
    if (!youtubeId) {
      const embedRegex = /youtube\.com\/embed\/([a-zA-Z0-9_-]+)/i;
      const embedMatch = input.match(embedRegex);
      if (embedMatch) {
        youtubeId = embedMatch[1];
      }
    }

    // Check for shorts URL
    if (!youtubeId) {
      const shortsRegex = /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/i;
      const shortsMatch = input.match(shortsRegex);
      if (shortsMatch) {
        youtubeId = shortsMatch[1];
      }
    }

    // If just a handle or ID was entered (no youtube.com in URL)
    if (!youtubeId) {
      if (input.startsWith('@')) {
        // Validate handle format - allow letters, numbers, underscores, dots
        const handleValue = input.substring(1);
        if (/^[a-zA-Z0-9_.-]+$/.test(handleValue)) {
          youtubeId = input; // Keep the @ symbol
        }
      }
      else if (input.match(/^[a-zA-Z0-9_-]{11}$/)) {
        // YouTube video IDs are exactly 11 characters
        youtubeId = input;
      }
      else if (input.match(/^[a-zA-Z0-9_.-]+$/)) {
        // Might be a channel handle without @
        youtubeId = `@${input}`;
      }
    }

    return youtubeId || input;
  }

  // Get full YouTube URL for display - FIXED VERSION
  getYouTubeUrl(identifier: string): string {
    if (!identifier) return '';

    // If it's already a full URL, return as is
    if (identifier.startsWith('http')) return identifier;

    // If it's a channel handle (@username)
    if (identifier.startsWith('@')) {
      // Ensure the handle is properly formatted
      const handle = identifier.substring(1);
      return `https://www.youtube.com/@${handle}`;
    }

    // If it's a video ID (11 characters)
    if (identifier.match(/^[a-zA-Z0-9_-]{11}$/)) {
      return `https://www.youtube.com/watch?v=${identifier}`;
    }

    // If it's a playlist or other type
    if (identifier.match(/^[a-zA-Z0-9_-]+$/)) {
      return `https://www.youtube.com/@${identifier}`;
    }

    return identifier;
  }

  // Facebook URL normalization
  normalizeFacebookUrl(input: string): string {
    if (!input) return '';

    input = input.trim();

    // Extract page/profile identifier
    let fbIdentifier = '';

    // Match facebook.com URLs
    const fbRegex = /(?:facebook\.com\/(?:profile\.php\?id=|pages\/[^\/]+\/)?)([a-zA-Z0-9\.]+)/i;
    const match = input.match(fbRegex);

    if (match) {
      fbIdentifier = match[1];
    }
    // If just a username was entered
    else if (input.match(/^[a-zA-Z0-9\.]+$/)) {
      fbIdentifier = input;
    }

    return fbIdentifier || input;
  }

  // Get full Facebook URL for display
  getFacebookUrl(identifier: string): string {
    if (!identifier) return '';
    if (identifier.startsWith('http')) return identifier;
    return `https://facebook.com/${identifier}`;
  }

  // Instagram URL normalization
  normalizeInstagramUrl(input: string): string {
    if (!input) return '';

    input = input.trim();

    // Extract username
    let igUsername = '';

    // Match instagram.com URLs
    const igRegex = /(?:instagram\.com\/(?:p\/|reel\/|tv\/)?)?([a-zA-Z0-9_\.]+)/i;
    const match = input.match(igRegex);

    if (match && match[1] && !match[1].includes('instagram.com')) {
      igUsername = match[1];
    }
    // If just a username was entered
    else if (input.match(/^[a-zA-Z0-9_\.]+$/)) {
      igUsername = input;
    }

    return igUsername || input;
  }

  // Get full Instagram URL for display
  getInstagramUrl(username: string): string {
    if (!username) return '';
    if (username.startsWith('http')) return username;
    // Remove @ if present at start
    username = username.replace(/^@/, '');
    return `https://instagram.com/${username}`;
  }

  // WhatsApp normalization
  normalizeWhatsApp(input: string): string {
    if (!input) return '';

    input = input.trim();

    // Extract phone number from various formats
    let phoneNumber = '';

    // Remove common prefixes
    let cleaned = input
      .replace(/^https?:\/\/(?:chat\.)?whatsapp\.com\//i, '')
      .replace(/^wa\.me\//i, '')
      .replace(/^api\.whatsapp\.com\/send\?phone=/i, '')
      .replace(/[^0-9+]/g, ''); // Keep only numbers and plus sign

    // Ensure it starts with country code
    if (cleaned.startsWith('+')) {
      phoneNumber = cleaned;
    }
    else if (cleaned.startsWith('91') && cleaned.length === 12) {
      phoneNumber = `+${cleaned}`;
    }
    else if (cleaned.length === 10) {
      phoneNumber = `+91${cleaned}`;
    }
    else {
      phoneNumber = cleaned;
    }

    return phoneNumber;
  }

  // Get full WhatsApp URL for display
  getWhatsAppUrl(phoneNumber: string): string {
    if (!phoneNumber) return '';
    if (phoneNumber.startsWith('http')) return phoneNumber;

    // Remove any non-digit characters except plus
    const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
    return `https://wa.me/${cleanNumber.replace('+', '')}`;
  }

  // Telegram normalization
  normalizeTelegram(input: string): string {
    if (!input) return '';

    input = input.trim();

    // Extract username or channel
    let telegramId = '';

    // Match telegram URLs
    const tgRegex = /(?:t\.me\/(?:s\/)?)([a-zA-Z0-9_]+)/i;
    const match = input.match(tgRegex);

    if (match) {
      telegramId = match[1];
    }
    // If just a username was entered
    else if (input.match(/^[a-zA-Z0-9_]+$/)) {
      telegramId = input;
    }
    else if (input.startsWith('@')) {
      telegramId = input.substring(1);
    }

    return telegramId || input;
  }

  // Get full Telegram URL for display
  getTelegramUrl(username: string): string {
    if (!username) return '';
    if (username.startsWith('http')) return username;
    return `https://t.me/${username.replace('@', '')}`;
  }


  // Safe getter for dynamic content - handles nested structures
  getSafeContent(projectId: number): any {
    const rawContent = this.ventureDynamicContent.get(projectId);
    if (!rawContent) return null;

    // Handle string content
    let content = rawContent;
    if (typeof content === 'string') {
      try {
        content = JSON.parse(content);
      } catch {
        return null;
      }
    }

    // ðŸ”¥ UNWRAP nested "DynamicContent" recursively
    while (content && content.DynamicContent) {
      content = content.DynamicContent;
    }

    // Also unwrap if the content itself is a string
    if (typeof content === 'string') {
      try {
        content = JSON.parse(content);
      } catch {
        return null;
      }
      while (content && content.DynamicContent) {
        content = content.DynamicContent;
      }
    }

    return content;
  }

  // Add this method inside your VenturesComponent class
  getStarArray(rating: number): any[] {
    if (rating && rating > 0) {
      return new Array(Math.floor(rating));
    }
    return [];
  }

}